import { render, staticRenderFns } from "./ImpLog.vue?vue&type=template&id=6f82af4c&scoped=true"
import script from "./ImpLog.vue?vue&type=script&lang=js"
export * from "./ImpLog.vue?vue&type=script&lang=js"
import style0 from "./ImpLog.vue?vue&type=style&index=0&id=6f82af4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f82af4c",
  null
  
)

export default component.exports